<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates28">
<p class="centerImage"><img alt="images" id="plate28" src="images/plate28.jpg"/></p>
<p class="caption">We ham-it up for the press: RWF, Bill Gibbs, and Jimmy Councer, taking down my action report.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates28.vue?447cd5c5